module.exports = __webpack_public_path__ + "img/foreign-outbounds.0a999f83.png";